import { Grid, Typography } from "@mui/material";
import { useTranslationContext } from "../../hooks/translations/translationsProvider";
import { BLACK } from "../../theme/colors";
import { IBuy } from "../../models/buy/Buy";
import { Trans } from "react-i18next";

interface BankTransferResponseProsp {
    response: IBuy;
    divisa: string
}

const BankTransferResponse:React.FC<BankTransferResponseProsp> = ({response, divisa}) => {

    const {t} = useTranslationContext();

    return(
        <>
            <Typography sx={{
                textAlign:'center',
                fontSize: '1.2em',
                letterSpacing:'0.01rem',
                fontWeight:500,
                paddingBottom:5,
            }}>
                {t("Ecco le coordinate bancarie da utilizzare per l'acquisto degli ASSO:")}
            </Typography>
                
                <Grid container marginBottom={2}>
                    <Grid item xs={3}>
                        <Typography variant="body1" fontSize={"0.9rem"} textAlign={"left"} fontWeight={"bold"}>
                            {t("Beneficiario")}:
                        </Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography variant="body1" fontSize={"1rem"} textAlign={"left"}>
                            {response.ibanOwner?.toUpperCase()}
                        </Typography>
                    </Grid>
                </Grid>

                <Grid container marginBottom={2}>
                    <Grid item xs={3}>
                        <Typography variant="body1" fontSize={"0.9rem"} textAlign={"left"} fontWeight={"bold"}>
                            {t("IBAN")}
                        </Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography variant="body1" fontSize={"1rem"} textAlign={"left"}>
                            {response.ibanReceiver?.toUpperCase()}
                        </Typography>
                    </Grid>
                </Grid>

                <Grid container marginBottom={2}>
                    <Grid item xs={3}>
                        <Typography variant="body1" fontSize={"0.9rem"} textAlign={"left"}   fontWeight={"bold"}>
                            BIC / SWIFT
                        </Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography variant="body1" fontSize={"0.8rem"} textAlign={"left"}>
                            {response.bicswiftReceiver?.toUpperCase()}
                        </Typography>
                    </Grid>
                </Grid>

                <Grid container marginBottom={2}>
                    <Grid item xs={3}>
                        <Typography variant="body1" fontSize={"0.9rem"} textAlign={"left"}   fontWeight={"bold"}>
                            { t("Banca") }:
                        </Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography variant="body1" fontSize={"0.8rem"} textAlign={"left"}>
                            {response.bankInfosReceiver}
                        </Typography>
                    </Grid>
                </Grid>

                <Grid container marginBottom={2}>
                    <Grid item xs={3}>
                        <Typography variant="body1" fontSize={"0.9rem"} textAlign={"left"}   fontWeight={"bold"}>
                            { t("Importo") }:
                        </Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography variant="body1" fontSize={"0.8rem"} textAlign={"left"}>
                            {response.amountLordoDivisa.toFixed(2)} {divisa}
                        </Typography>
                    </Grid>
                </Grid>

                <Grid container marginBottom={6}>
                    <Grid item xs={3}>
                        <Typography variant="body1" fontSize={"0.9rem"} textAlign={"left"}   fontWeight={"bold"}>
                            { t("Causale")}*:
                        </Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography variant="body1" fontSize={"0.8rem"} textAlign={"left"} fontWeight={"bold"}>
                            {response.refCode}
                        </Typography>
                    </Grid>
                </Grid>
                
                <Typography sx={{
                textAlign:'center',
                fontSize: '1em',
                letterSpacing:'0.01rem',
                fontWeight:500,
                }}>
                    <Trans i18nKey="attenzione-bonifico-response" components={{
                        strong: <strong />,
                    }}/>
                </Typography>
        </>
    )
}

export default BankTransferResponse;